import React from "react";

export function PageHeader({ eyebrow, title, sub, action, testId }) {
  return (
    <div className="border-b border-zinc-200 px-6 sm:px-10 py-6 sm:py-8 flex items-end justify-between gap-4 flex-wrap" data-testid={testId}>
      <div>
        {eyebrow && <p className="label-eyebrow text-zinc-500 mb-2">{eyebrow}</p>}
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter">{title}</h1>
        {sub && <p className="text-zinc-600 mt-2 text-sm max-w-2xl">{sub}</p>}
      </div>
      {action}
    </div>
  );
}

export function PageBody({ children, className = "" }) {
  return <div className={`px-6 sm:px-10 py-8 ${className}`}>{children}</div>;
}

export function StatTile({ label, value, hint, accent, testId }) {
  return (
    <div className="border border-zinc-200 p-5 bg-white" data-testid={testId}>
      <p className="label-eyebrow text-zinc-500">{label}</p>
      <div className={`font-display font-black text-3xl sm:text-4xl mt-3 tracking-tighter ${accent ? "text-orange-600" : "text-zinc-900"}`}>
        {value}
      </div>
      {hint && <p className="text-xs text-zinc-500 mt-2 mono">{hint}</p>}
    </div>
  );
}

export function EmptyState({ title, sub, action }) {
  return (
    <div className="border border-dashed border-zinc-300 p-10 sm:p-16 text-center bg-zinc-50/50">
      <p className="label-eyebrow text-zinc-400">// No data</p>
      <h3 className="font-display font-bold text-2xl mt-3">{title}</h3>
      {sub && <p className="text-sm text-zinc-500 mt-2 max-w-md mx-auto">{sub}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
